import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {breakpointDown} from './utils/breakpoints';

gsap.registerPlugin(ScrollTrigger);

let layoutScrollTriggers = [];

function initLayoutScroll() {
  if (!$('#layout-scroll').length) return false;

  // Clear any previous ScrollTriggers
  layoutScrollTriggers.forEach((trigger, index) => {
    trigger.kill()
    ScrollTrigger.getById(`panel-scroll-${index}`)?.kill(true);
  });
  layoutScrollTriggers = [];

  if ($(window).width() < 1024) return false;

  let panels = gsap.utils.toArray(".panel");

  // Create a ScrollTrigger for each panel to track when each panel's top hits the top of the viewport
  let tops = panels.map(panel => {
    let trigger = ScrollTrigger.create({trigger: panel, start: "top top"});
    layoutScrollTriggers.push(trigger);
    return trigger;
  });

  panels.forEach((panel, i) => {
    let trigger = ScrollTrigger.create({
      id: `panel-scroll-${i}`,
      trigger: panel,
      start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",
      pin: true,
      pinSpacing: false,
      scrub: 0.3,
    });
    layoutScrollTriggers.push(trigger);
  });

  // Uncomment and adjust this section if you want to add the inner-animation ScrollTrigger
  // let innerAnimationTrigger = ScrollTrigger.create({
  //   trigger: '.inner-animation',
  //   start: 'top top',
  //   end: '+=300',
  //   scrub: 0.3,
  //   //markers: true
  // });
  // layoutScrollTriggers.push(innerAnimationTrigger);
}
$(document).ready(function () {
  initLayoutScroll();
})

// Initial call to setup layout scroll

// Reinitialize on window resize
window.addEventListener('resize', initLayoutScroll);
